export const res_regist = {
  methods: {
    regist_data: function(module, extra_path, prev_module){
      this.executing = true;
      var url = this.$store.getters.api_endpoint + "/" + module + extra_path;
      this.$http.post(url,
                      this.parameters,
                      {
                        headers: {
                          'Content-Type': 'application/json'
                        },
                      })
        .then( response => {
          this.$store.commit("setNotification", {
            type: "success",
            message: {
              eid: "E1" + this.module_id + "005" + ":00000000",
              param: {}
            }
          });
          this.$router.push(this.get_prev(this.get_prefix() + prev_module));
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    get_prev: function(module){
      var prev = "/" + module;
      if(this.$route.query.referer){
        var referers = this.$route.query.referer.split(":");
        prev = referers.pop();
        if(referers.length > 0){
          prev += "?referer=" + encodeURIComponent(referers.join(":"));
        }
      }
      return prev;
    },
    get_prefix: function(){
      return this.mode + "/";
    },
    reset_target: function(layer){
      switch(layer){
        case "system":
          this.target.did = "";
        case "division":
          this.target.aid = "";
        case "agency":
          this.target.nid = "";
        case "organization":
          this.target.gid = "";
          this.target.uid = "";
      }
    }
  }
}
